// extracted by mini-css-extract-plugin
export default {"textfield__hint":"MultipleKeywordsInput_textfield__hint__nfp0x","textfield__hint--grey":"MultipleKeywordsInput_textfield__hint--grey__P6faN"};